import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { addWarningNotification } from '@application/features/common/notificationSlice';
import { useAppDispatch } from '@application/store/useStore';
import { IonIcon } from '@ionic/react';
import VnButton from '@ui/components/VnButton';
import { documentOutline, cloudUploadOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import '@ui/styles/attachments-style.css';
import { addAttachmentsByOrderIdAsync, getAllAttachmentsByOrderIdAsync } from '@application/features/orders/orderThunk';
const AddAttachmentsForm = ({ onClose, formData, isAttachmentTabBold }) => {
    const [file, setFile] = useState('');
    const fileLimit = 2 * 1024 * 1024;
    const dispatch = useAppDispatch();
    const [droppStyling, setDroppStyling] = useState({ backgroundColor: '#EBF7FD', border: 'none', paddingRight: '700px', postion: 'relative', left: '-30px', top: '-15px', right: '' });
    const handleFileUpload = (files) => {
        setFile(files);
    };
    const uploadFile = () => {
        if (file) {
            if (file.size <= fileLimit) {
                if (![
                    'image/jpeg',
                    'image/png',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                    'application/pdf',
                    'text/csv'
                ].includes(file.type)) {
                    dispatch(addWarningNotification('Alleen jpeg, jpg, png, pdf, csv, xls en xlsx bestanden zijn toegestaan'));
                }
                else {
                    dispatch(addAttachmentsByOrderIdAsync({ orderId: formData.id, document: file }))
                        .unwrap()
                        .then((res) => {
                        dispatch(getAllAttachmentsByOrderIdAsync(formData.id))
                            .unwrap()
                            .then((res) => {
                            if (isAttachmentTabBold && res.length > 0) {
                                isAttachmentTabBold(true);
                            }
                            else {
                                isAttachmentTabBold && isAttachmentTabBold(false);
                            }
                        });
                        onClose();
                        setFile('');
                    });
                }
            }
        }
    };
    const FileUploaderDesign = (_jsxs("div", { className: 'container Vn-fileuploader-container-styling', children: [_jsxs("div", { className: 'Vn-fileUploader-styling mt-4', children: [_jsx(IonIcon, { icon: cloudUploadOutline, className: 'Vn-custom-icon' }), _jsx("div", { children: _jsx("p", { children: "Klik of sleep een bestand naar dit gebied om te uploaden." }) }), _jsx("div", { children: _jsx("p", { children: "Maximale bestandsgrootte 2MB." }) })] }), _jsx("div", { className: 'Vn-fileUploaded-styling mt-3', children: _jsx("div", { className: file.size <= fileLimit ? '' : 'vn-input-field-error', children: file ? (file.size <= fileLimit ? (_jsxs("div", { className: 'd-flex', children: [_jsx("div", { className: 'Vn-settings-custom-icon', children: _jsx(IonIcon, { icon: documentOutline }) }), _jsxs("div", { children: [" ", file.name] })] })) : ('Bestandsgrootte overschrijdt de limiet van 2 MB.')) : ('') }) })] }));
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 992) {
                setDroppStyling({ backgroundColor: '#EBF7FD', border: 'none', paddingRight: '100px', postion: 'relative', left: '-10px', top: '-13px', right: '-15px' });
            }
            else {
                setDroppStyling({ backgroundColor: '#EBF7FD', border: 'none', paddingRight: '700px', postion: 'relative', left: '-30px', top: '-15px', right: '' });
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(FileUploader, { children: FileUploaderDesign, multiple: false, name: 'file', handleChange: handleFileUpload, dropMessageStyle: droppStyling, classes: 'vn-fileupload-wrapper', hoverTitle: ' ' }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', type: 'button', onClick: onClose, children: "Annuleren" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'button', onClick: uploadFile, children: "Opslaan" })] }) })] }));
};
export default AddAttachmentsForm;
